import React, { useEffect } from "react";
import { SubModule } from "../types/SubModule";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { Edit, Trash } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { fetchSubModules } from "../redux/actions/subModuleAction";
import { AppDispatch } from "../redux/store";
import { fetchModules } from "../redux/actions/moduleAction";
import "../styles/EmployeeList.css";

interface Props {
  subModules: SubModule[];
  onEdit: (sub: SubModule) => void;
  onDelete: (id: number) => void;
}

const SubModuleList: React.FC<Props> = ({ subModules, onEdit, onDelete }) => {
  const modules = useSelector((state: StoreState) => state.module);
  const dispatch = useDispatch<AppDispatch>();

  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete details</Popover.Body>
    </Popover>
  );
  useEffect(() => {
    dispatch(fetchSubModules());
  }, []);
  useEffect(() => {
    dispatch(fetchModules());
  }, []);

  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Module</th>
          <th>Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {subModules.map((sub, index) => {
          const module = modules.find(
            (p) => Number(p.id) === Number(sub.moduleId),
          );
          const moduleName = module?.name;

          return (
            <tr key={sub.id}>
              <td>{index + 1}</td>
              <td>{moduleName}</td>
              <td>{sub.name}</td>
              <td className="d-flex no-wrap border-0 justify-content-center">
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={editPopover}
                >
                  <Button
                    variant="warning"
                    className="mr-2"
                    onClick={() => onEdit(sub)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Edit />
                  </Button>
                </OverlayTrigger>
                {/* <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={deletePopover}
                >
                  <Button
                    variant="danger"
                    onClick={() => onDelete(sub.id)}
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                    }}
                  >
                    <Trash />
                  </Button>
                </OverlayTrigger> */}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default SubModuleList;
